import { getInTouchPopup } from "@partials/get-in-touch/get-in-touch";
import validateForm from "./validateForm";
import { formSubject } from "@partials/UI/form/form";
import { successForm, unsuccessForm, createInstanceNotification } from "@partials/UI/notifications/notifications";

export default async function sendForm(form, token = null) {
    try {
        const isValid = validateForm(form);

        if (isValid) {
            const phpHandlerUrl = "../libs/telegram.php";
            const formData = new FormData(form);

            token && formData.append("g-recaptcha-response", token);

            const response = await fetch(phpHandlerUrl, {
                method: "POST",
                body: formData,
            });

            if (response.ok) {
                for (let item of document.querySelectorAll(".form .field")) item.value = "";

                if (getInTouchPopup.$selector) getInTouchPopup.close();
                createInstanceNotification(successForm).open();

                //  Отслеживание конверсии для Google Analytics 4 (GTM)
                formSubject = formSubject ?? "";
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: "order_success",
                    value: formSubject,
                });
            } else {
                createInstanceNotification(unsuccessForm).open();
            }
        }
    } catch (error) {
        // fromStatus.classList.add('error')
        // fromStatus.innerText = 'Ошибка. Форма не отправлена'
        // createInstanceNotification(unsuccessForm).open()
    }
}
